import { robot } from '@/utils/dictionary/waybillselect';

import { getConvoyListByPage, getDriverList, pageCollectInfo } from '@/api/capacity';

const storeModelName = 'driverModule';
const state = {
  driverProperty: 'transfer',
  // 筛选项
  parameters: [
    {
      style: 'input',
      value: '',
      label: '姓名',
      placeholder: '请输入',
      clearable: true,
      param: 'name',
    },
    {
      style: 'input',
      value: '',
      label: '手机号',
      placeholder: '请输入',
      clearable: true,
      param: 'mobile',
    },
    {
      style: 'input',
      value: '',
      label: '车牌号',
      placeholder: '请输入',
      clearable: true,
      param: 'vehicleNo',
    },
    {
      style: 'select',
      value: '',
      state: 'convoyList',
      label: '车队',
      placeholder: '请选择',
      noMatchText: '无匹配车队',
      clearable: true,
      filterable: true,
      param: 'convoyId',
      path: `${storeModelName}/getConvoyList`,
    },
    {
      style: 'date-picker',
      value: [],
      label: '创建时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      param: 'createTime',
      params: ['startCreateTime', 'endCreateTime'],
    },
    {
      style: 'input',
      value: '',
      label: '创建人',
      placeholder: '请输入',
      clearable: true,
      param: 'creatorName',
    },
    {
      style: 'select',
      value: '',
      state: 'collectInfoList',
      label: '默认收款人',
      placeholder: '请选择',
      noMatchText: '无匹配默认收款人',
      clearable: true,
      filterable: true,
      param: 'collectInfoId',
      path: `${storeModelName}/getCollectInfoList`,
    },
  ],
  transferParams: [
    {
      style: 'input',
      value: '',
      label: '姓名',
      placeholder: '请输入',
      clearable: true,
      param: 'name',
    },
    {
      style: 'input',
      value: '',
      label: '手机号',
      placeholder: '请输入',
      clearable: true,
      param: 'mobile',
    },
    {
      style: 'input',
      value: '',
      label: '车牌号',
      placeholder: '请输入',
      clearable: true,
      param: 'vehicleNo',
    },
    {
      style: 'select',
      value: '',
      state: 'convoyList',
      label: '车队',
      placeholder: '请选择',
      noMatchText: '无匹配车队',
      clearable: true,
      filterable: true,
      param: 'convoyId',
      path: `${storeModelName}/getConvoyList`,
    },
    {
      style: 'date-picker',
      value: [],
      label: '创建时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      param: 'createTime',
      params: ['startCreateTime', 'endCreateTime'],
    },
    {
      style: 'input',
      value: '',
      label: '创建人',
      placeholder: '请输入',
      clearable: true,
      param: 'creatorName',
    },
    {
      style: 'select',
      value: '',
      state: 'collectInfoList',
      label: '默认收款人',
      placeholder: '请选择',
      noMatchText: '无匹配默认收款人',
      clearable: true,
      filterable: true,
      param: 'collectInfoId',
      path: `${storeModelName}/getCollectInfoList`,
    },
  ],
  ownParams: [
    {
      style: 'input',
      value: '',
      label: '姓名',
      placeholder: '请输入',
      clearable: true,
      param: 'name',
    },
    {
      style: 'input',
      value: '',
      label: '手机号',
      placeholder: '请输入',
      clearable: true,
      param: 'mobile',
    },
    {
      style: 'input',
      value: '',
      label: '车牌号',
      placeholder: '请输入',
      clearable: true,
      param: 'vehicleNo',
    },
    {
      style: 'select',
      value: '',
      state: 'convoyList',
      label: '车队',
      placeholder: '请选择',
      noMatchText: '无匹配车队',
      clearable: true,
      filterable: true,
      param: 'convoyId',
      path: `${storeModelName}/getConvoyList`,
    },
    {
      style: 'date-picker',
      value: [],
      label: '创建时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      param: 'createTime',
      params: ['startCreateTime', 'endCreateTime'],
    },
    {
      style: 'input',
      value: '',
      label: '创建人',
      placeholder: '请输入',
      clearable: true,
      param: 'creatorName',
    },
  ],
  // 筛选项 select需要的列表
  convoyList: [],
  collectInfoList: [],
  // 配置是否导出
  isExport: {
    isShow: false,
  },
  // 接口调用参数
  postParams: {
    page: 1,
    size: 10,
  },
  transferHeader: [
    {
      label: '司机',
      prop: 'name',
      checked: 1,
      width: 150,
      sortable: true,
      slotName: 'sub-domain-name',
    },
    {
      label: '认证状态',
      prop: 'completeInfo',
      width: 120,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-completeInfo',
    },
    {
      label: '关联车辆',
      prop: 'vehicleNos',
      width: 200,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-vehicleNos',
    },
    {
      label: '车队',
      prop: 'convoyName',
      width: 140,

      checked: 1,
      sortable: true,
    },
    {
      label: '默认收款人',
      prop: 'collectInfoName',
      checked: 1,
      sortable: true,
    },
    {
      label: '补贴油款钱包（元）',
      prop: 'lsOil',
      checked: 1,
      width: 140,
      sortable: true,
      slotName: 'sub-domain-lsOil',
    },
    {
      label: '长期油款钱包（元）',
      width: 160,
      prop: 'oilAmount',
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-oilAmount',
    },
    {
      label: '创建时间',
      prop: 'createTime',
      width: 180,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-createTime',
    },

    {
      label: '操作',
      prop: '',
      width: 130,
      checked: 1,
      sortable: true,
      fixed: 'right',
      slotName: 'sub-domain-status',
    },
  ],
  ownerHeader: [
    {
      label: '司机',
      prop: 'name',
      checked: 1,
      width: 140,
      sortable: true,
      slotName: 'sub-domain-name',
    },
    {
      label: '关联车辆',
      prop: 'vehicleNo',
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-vehicleNo',
    },
    {
      label: '车队',
      prop: 'convoyName',
      checked: 1,
      sortable: true,
    },
    {
      label: '司机油款钱包（元）',
      prop: 'oilAmount',
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-oilAmount',
    },
    {
      label: '创建时间',
      prop: 'createTime',
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-createTime',
    },
    {
      label: '操作',
      prop: '',
      width: 130,
      checked: 1,
      sortable: true,
      fixed: 'right',
      slotName: 'sub-domain-status',
    },
  ],
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '司机',
        prop: 'name',
        checked: 1,
        width: 150,
        sortable: true,
        slotName: 'sub-domain-name',
      },
      {
        label: '认证状态',
        prop: 'completeInfo',
        width: 120,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-completeInfo',
      },
      {
        label: '关联车辆',
        prop: 'vehicleNo',
        width: 120,
        checked: 1,
        sortable: true,
      },
      {
        label: '车队',
        prop: 'convoyName',
        width: 140,

        checked: 1,
        sortable: true,
      },
      {
        label: '默认收款人',
        prop: 'collectInfoName',
        checked: 1,
        sortable: true,
      },
      {
        label: '补贴油款钱包（元）',
        prop: 'lsOil',
        checked: 1,
        width: 140,
        sortable: true,
        slotName: 'sub-domain-lsOil',
      },
      {
        label: '长期油款钱包（元）',
        width: 160,
        prop: 'oilAmount',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-oilAmount',
      },
      {
        label: '创建时间',
        prop: 'createTime',
        width: 180,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-createTime',
      },

      {
        label: '操作',
        prop: '',
        width: 130,
        checked: 1,
        sortable: true,
        fixed: 'right',
        slotName: 'sub-domain-status',
      },
    ],
    total: 0,
  },
  total: 0,
  from: '',
  report: {},
  reportAll: {},
  batchStatus: '',
  robot,
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple) {
          if (item.value.length > 0) {
            params[item.param] = item.value.toString();
          }
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    context.commit(
      'updateEditTableList',
      context.state.driverProperty === 'transfer'
        ? context.state.transferHeader
        : context.state.ownerHeader,
    );
    getDriverList(
      Object.assign(
        {},
        {
          page: context.state.postParams.page,
          size: context.state.postParams.size,
        },
        params,
        { driverProperty: context.state.driverProperty },
      ),
    ).then(res => {
      context.commit('updateListData', Object.assign({}, context.state.listData, res.data));
    });
  },
  getConvoyList: async (context, payload) => {
    const { code, data } = await getConvoyListByPage({
      name: payload,
    });
    if (code === 200) {
      data.forEach(item => {
        item.label = item.name;
        item.value = item.id;
      });
      context.commit('updateConvoyList', data);
    }
  },
  getCollectInfoList: async (context, payload) => {
    const { code, data } = await pageCollectInfo({
      payeeName: payload,
      page: 1,
      size: 10,
    });
    if (code === 200) {
      data.records.forEach(item => {
        item.label = item.payeeName;
        item.value = item.id;
      });
      context.commit('updateCollectInfoList', data.records);
    }
  },
};

// mutations
const mutations = {
  // 更新data数据
  updateListData(state, payload) {
    state.listData = payload;
  },
  // 更新列表表头数据
  updateEditTableList(state, payload) {
    state.listData.tableHeadList = payload;
  },
  // 更新进入页面
  updateFrom(state, payload) {
    state.from = payload;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 更新车队列表
  updateConvoyList(state, payload) {
    state.convoyList = payload;
  },
  // 更新收款人列表
  updateCollectInfoList(state, payload) {
    state.collectInfoList = payload;
  },
  // 更新运营经理列表
  updateOperates(state, payload) {
    state.operates = payload;
  },
  // 更新销售经理列表
  updateSales(state, payload) {
    state.sales = payload;
  },
  // 更新线路列表
  updateOrders(state, payload) {
    state.orders = payload;
  },
  // 更新统计信息
  updateReport(state, payload) {
    state.report = payload;
  },
  // 更新统计信息
  updateReportAll(state, payload) {
    state.reportAll = payload;
  },
  // 重置所有状态
  initFilter(state) {
    state.driverProperty = 'transfer';
    state.postParams = {
      size: 10,
      page: 1,
    };
    state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple) {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        if (item.param === 'createTime') {
          item.value = [];
        }
      }
    });
  },
  updateDriverProperty(state, payload) {
    state.driverProperty = payload;
  },
  // 更新筛选
  updateEditParams(state, payload) {
    state.parameters = payload === 'transfer' ? state.transferParams : state.ownParams;
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
  },
  // 根据index更新状态
  updateSpecialStatusFromIndex(state, payload) {
    state.isSpecialButton[payload.index].selectList.forEach((item, index) => {
      item.isActive = index === payload.index1;
    });
  },
  // 根据index更新状态
  updateSpecialTabsStatusFromIndex(state, payload) {
    state.isSpecialTabs[0].selectList.forEach((item, index) => {
      item.isActive = index === payload.index;
    });
    state.isSpecialTabs[0].status = state.isSpecialTabs[0].selectList[payload.index].value;
  },
  updateBatchChange(state, payload) {
    state.batchStatus = payload;
  },
  // 更行行内数据
  updateTableDataByIndex(state, payload) {
    state.listData.list[payload.index] = payload.info;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
